<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>Manage user projects</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
    <!-- <mat-form-field>
      <mat-label>matff</mat-label>
      <mat-select>
        @for (action of actions; track action) {
          <mat-option [value]="action.key || action.label">{{ action.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field> -->
    <mat-form-field style="width: 100%;">
        <mat-label>Filter depts, efforts, and projects</mat-label>
        <input matInput [formControl]="filter" />
        <button mat-icon-button matSuffix (click)="filter.setValue('')"><mat-icon>clear</mat-icon></button>
    </mat-form-field>
    <!-- <mat-grid-list cols="4" rowHeight="1.5em">
        @for (dept of depts; track dept) {
            <mat-grid-tile colspan='4' [innerHTML]="dept.name | highlight: searchTerms" class="project"></mat-grid-tile>
            <mat-grid-tile rowspan="2" class="tools"><mat-icon>remove</mat-icon></mat-grid-tile>
            <mat-grid-tile colspan='3' [innerHTML]="proj.effort.title | highlight: searchTerms" class="effort"></mat-grid-tile>
        }
    </mat-grid-list> -->
    <mat-tree [dataSource]="dataSource" class="example-tree" [childrenAccessor]="childrenAccessor" #tree>
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <mat-checkbox [checked]="selection.isSelected(node)" [indeterminate]="descendantsPartiallySelected(node)" [disabled]="node?.effort?.isHR"
                (change)="toggleSelection(node)" class='leaf' [class]="getMembershipStatus(node)">
                <span [innerHTML]="(node.name ?? node.title) | highlight: searchTerms"></span>&nbsp;
                @switch (getMembershipStatus(node)) {
                    @case("added") { <span class="note added">(to be added)</span> }
                    @case("removed") { <span class="note removed">(to be removed)</span> }
                }
            </mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding (expandedChange)="toggleNode(node)" class="parentof" [class]="getParentOfMembershipStatuses(node)" [ngStyle]="{'--fade-delay': (0.05+indexOf(node) * 0.01) + 's'}">
            <mat-checkbox [checked]="selection.isSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
                (change)="toggleSelection(node)" [disabled]="! childrenAccessor(node).length">
                <span [innerHTML]="(node.name ?? node.title) | highlight: searchTerms"></span>&nbsp;({{ summary(node) }})
            </mat-checkbox>
            <button mat-icon-button matTreeNodeToggle [disabled]="! childrenAccessor(node).length">
                <mat-icon>
                    {{isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
        </mat-tree-node>
    </mat-tree>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
    <div class="effect-summary">
        Change Summary:
        <ul>
            <li>{{ data?.user?.displayName }} is a member of {{ countMemberships(dataSource.data) }} project(s).</li>
            <li><span style="display: inline-block;">
                @let added = countAdded(dataSource.data);
                @let removed = countRemoved(dataSource.data);
                @if (!added && !removed) {
                    You haven't made any changes to this.
                } @else {
                    Your update will
                    @if (added)  {                    
                        <a (click)='viewAdds()' [routerLink]="[]" queryParamsHandling="merge" title="View memberships to add."  class='summary' [class]="countAdded(dataSource.data) ? 'added' : ''">add them to {{ countAdded(dataSource.data) }} project(s)</a>
                    }
                    @if (countAdded(dataSource.data) && countRemoved(dataSource.data)) { and }
                    @if (countRemoved(dataSource.data)) {
                        <a (click)='viewRemoves()' [routerLink]="[]" queryParamsHandling="merge" title='View memberships to remove.' class='summary' [class]="countRemoved(dataSource.data) ? 'removed' : ''">remove them from {{ countRemoved(dataSource.data) }} project(s)</a>
                    }.
                }
            </span></li>
        </ul>
        @if (hasSaveError) {
            <div style="color: red;">There was an error while trying to save these bulk changes.</div>
        }
    </div>
    <button mat-flat-button (click)='reset()'>Reset</button>
    <button mat-flat-button (click)='cancel()'>Cancel</button>
    <button mat-flat-button (click)='save()'>Save</button>
</mat-dialog-actions>